import { getKnownRoles } from './http/access-ws/roles';
import type { QueryClient } from '@tanstack/query-core';
import type { UseQueryOptions } from '@tanstack/react-query';
import { allWidgets } from 'src/lib/widget/widgets';

// query keys
const KNOWN_ROLES = 'known-roles';

const selectWidgetEntitlementsAndMergeWithKnownEntitlements = (knownEntitlements: string[]): string[] => {
    const entitlementSet = new Set([...knownEntitlements]);
    for (const widgetDefinition of Object.values(allWidgets)) {
        for (const role of widgetDefinition.roles) {
            entitlementSet.add(role);
        }
    }
    return Array.from(entitlementSet);
};

export const getKnownRolesQuery = (): UseQueryOptions<Awaited<ReturnType<typeof getKnownRoles>>> => {
    return {
        queryKey: [KNOWN_ROLES],
        queryFn: () => getKnownRoles(),
        select: selectWidgetEntitlementsAndMergeWithKnownEntitlements,
    };
};

// cache-invalidation
export const invalidateKnownRolesQuery = (queryClient: QueryClient) => {
    return queryClient.invalidateQueries({ queryKey: [KNOWN_ROLES], exact: true });
};
